function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#4CBBB9",
  fillOpacity: 0.2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 23,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 5,
  r: 5
}));

var SvgBackground = function SvgBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgdmlld0JveD0iMCAwIDM2IDM2Ij4KICAgIDxnIGZpbGw9IiM0Q0JCQjkiIGZpbGwtb3BhY2l0eT0iLjIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPGNpcmNsZSBjeD0iMTMiIGN5PSIyMyIgcj0iMTMiLz4KICAgICAgICA8Y2lyY2xlIGN4PSIzMSIgY3k9IjUiIHI9IjUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgBackground as ReactComponent };